/**
 * @func randomKey
 * @param {number} length - optional length parameter defaults to 4 digit
 * @return {number}
 * ```js
 * randomKey();
 * // returns e.g. 2637;
 *
 * randomKey(2);
 * // returns e.g. 56;
 * ```
 * @memberof module:Number
 * @instance
 */
function randomKey(length = 4) {
    const min = Math.pow(10, (length - 1));
    const max = Math.pow(10, length);
    const randomNumber = Math.random() * (max - min) + min;
    return randomNumber.toFixed();
}

export { randomKey as default };
